
import React from "react";
import CleanHeroSection from "@/components/landing/CleanHeroSection";
import DualServiceFeatures from "@/components/landing/DualServiceFeatures";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import CTASection from "@/components/landing/CTASection";
import SimplifiedRefundForm from "@/components/landing/SimplifiedRefundForm";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <CleanHeroSection />
      <SimplifiedRefundForm id="refund-form-section" />
      <DualServiceFeatures />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
};

export default Index;
